export const headConstants = {
  healthyWeightTitle: "Noom: Stop dieting. Get life-long results.",
  healthyWeightDescription:
    "Ready to stop dieting? Start Noom - an award-winning weight-loss program designed by psychologists & scientifically proven to create real, sustainable results.",
  homepageHrefLangMappings: [
    { href: "https://www.noom.com/en-GB/", hreflang: "en-gb" },
    { href: "https://www.noom.com/en-AU/", hreflang: "en-au" },
    { href: "https://www.noom.com/en-NZ/", hreflang: "en-nz" },
    { href: "https://www.noom.com/de-DE/", hreflang: "de-de" },
    { href: "https://www.noom.com/es-ES/", hreflang: "es-es" },
    { href: "https://www.noom.com/en-IE/", hreflang: "en-ie" },
    { href: "https://www.noom.com/ja-JP/", hreflang: "ja-jp" },
    { href: "https://noom.co.kr/moneyback.html", hreflang: "ko-kr" },
    { href: "https://www.noom.com", hreflang: "en" },
    { href: "https://www.noom.com/ja/", hreflang: "ja" },
    { href: "https://www.noom.com/de/", hreflang: "de" },
    { href: "https://www.noom.com/es/", hreflang: "es" },
    { href: "https://www.noom.com", hreflang: "x-default" },
  ],
};

export const routeConstants = {
  affiliateNoTrial: "aff-ntrl",
  affiliateNoTrialPromo: "aff-ntrl-prm",
  app14DayFtWeb: "app-14-day-ft-web",
  app14DayFt: "app-14-day-ft",
  app14DayReturning: "app-14-day-returning",
  app14DayWeb: "app-14-day-web",
  emailMain: "email-main",
  emailWinback: "email-winback",
  exsf01: "exsf01",
  exsf01d: "exsf01d",
  direct: "_direct",
  rfqa: "rfqa",
  rfqaPromo: "rfqa-promo",
  winback: "winback",
};
